<script lang="ts">
	import { fade } from 'svelte/transition';
	import Close from './icons/close.svelte';
	import VideoPlayer from './videoPlayer.svelte';
	import Button from './buttons/v3/button.svelte';
	import { onDestroy } from 'svelte';

	interface Props {
		onclose?: () => void;
		playbackId: string;
		backgroundWithOpacity?: boolean;
		buttonPos?: 'top-left' | 'top-right';
	}

	let {
		onclose,
		playbackId,
		backgroundWithOpacity = false,
		buttonPos = 'top-left'
	}: Props = $props();

	let videoElement = $state<HTMLVideoElement>();
	let showVideo = $state(false);

	let container: HTMLDivElement;

	$effect(() => {
		if (container) {
			document.body.appendChild(container);
		}
	});

	$effect(() => {
		if (showVideo) {
			videoElement?.play();
		}
	});

	onDestroy(() => {
		container?.remove();
	});
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class={[
		'fixed inset-0 z-[70] flex items-center justify-center bg-black',
		{ 'bg-opacity-70': backgroundWithOpacity }
	]}
	in:fade={{ duration: 400 }}
	bind:this={container}
	onintroend={() => (showVideo = true)}
>
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<div
		class={[
			'flex h-full w-full items-center justify-center transition-opacity duration-600 ease-out lg:p-10',
			{
				'opacity-0': !showVideo,
				'opacity-100': showVideo
			}
		]}
		onclick={onclose}
	>
		<VideoPlayer
			bind:videoElement
			loop={false}
			autoplay={null}
			muted={false}
			fit="contain"
			controls
			{playbackId}
			wrapperClass="rounded-none sm:rounded-lg 2xl:rounded-xl overflow-hidden h-full"
			class="h-full"
		/>
	</div>
	{#if showVideo}
		<div
			class={[
				'absolute top-6',
				{ 'left-6': buttonPos === 'top-left', 'right-6': buttonPos === 'top-right' }
			]}
		>
			<Button class="btn-white" onclick={() => onclose?.()}><Close class="h-6 w-6" /></Button>
		</div>
	{/if}
</div>
